export enum SizeBasedOn {
  CHILD_COUNT = 'childCount',
  OUTGOING_LINKS = 'outgoingLinks',
  INCOMING_LINKS = 'incomingLinks',
}
export const MAX_LIMIT_VALUES = [10, 20, 30];
export const SHOW_ALL_COMPONENTS = -1;
